import React, { Component } from 'react';
import { Context } from 'context';
import PropTypes from 'prop-types';

import styles from './Folder.module.scss';
import CodeLabel from "components/codeLabel/CodeLabel";
import Expander from "components/expander/Expander";

class Folder extends Component {
    static propTypes = {
        folder: PropTypes.object.isRequired,
    };

    static contextType = Context;

    render() {
        const containsEditedMaps = this.props.folder.codeNames.some(map => map.swModified);
        const containsOpenMaps = this.props.folder.codeNames.some(map => this.context.windows.some(window => window.mapId === map.id))
        return (
            <Expander
                startClosed
                className={styles.folder}
                closedClassName={styles.closed}
            >
                <div className={styles.header}>
                    <img src={require(`images/icons/arrow${this.context.lightTheme ? "-light" : "-dark"}.svg`)} alt="Arrow" />
                    <div className={styles.description}>
                        <CodeLabel
                            code={this.props.folder.title.split(":")[0]}
                            className={containsEditedMaps ? styles.containsEditedMaps : "ungrouped"}
                        />
                        <p
                            className={`txtSecondary ${containsOpenMaps && styles.containsOpenMaps}`}
                            title={this.props.folder.titleDescription}
                        >
                            {this.props.folder.titleDescription}
                        </p>
                        <span className={`${styles.length} txtTertiary`}>({this.props.folder.codeNames.length})</span>
                    </div>
                </div>
                <div className={styles.maps}>
                    {this.props.children}
                </div>
            </Expander>
        )        
    }
}

export default Folder;
